// Components
import DisplayMode from 'components/filter/searchandsort/displaymode'
import SortMode from 'components/browse/sortmode'
import SearchInputField from 'components/browse/searchinputfield'

import styles from './searchandsort.css'

type SearchAndSortProps = {
  sortModes: Array<{ value: number; name: string }>
  filterInputPlaceholder: string
  hideDisplayMode?: boolean
}

const SearchAndSort = ({ sortModes, filterInputPlaceholder, hideDisplayMode }: SearchAndSortProps): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <SearchInputField className={styles.search} filterInputPlaceholder={filterInputPlaceholder} />
      <div className={styles.right}>
        {sortModes.length > 0 && <SortMode sortModes={sortModes} className={styles.sortMode} />}
        {!hideDisplayMode && <DisplayMode />}
      </div>
    </div>
  )
}

export default SearchAndSort
